import { Input } from "@progress/kendo-react-inputs";

export const DefaultNumericValueProperty = {
  propertyName: "DefaultValue",
  propertyDisplay: "Default Value",
  propertyType: "number",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Input
        name={this.propertyName}
        type={"number"}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        value={currentPropertyValues?.[this.propertyName] ?? ""}
      />
    );
  },
};
